import {fadi_shawki} from "./fadi-shawki/fadi_shawki";

export const PROFILES = { fadi_shawki }

